import { IGameLoader } from "./Types";
import React, { useEffect, useState } from "react";
import { FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "../../../../Api/gen";

export const IframeLoader = (props: IGameLoader) => {
	log.info("Render IframeLoader...");

	const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>();
	const [iframeLoaded, setIframeLoaded] = useState<boolean>();

	const iframeOptions = props.buildConfig;

	const windowSearchParams = new URLSearchParams(document.location.search);
	let iframeUrl = new URL(iframeOptions.IframeGame!.IframeUrl);

	if (import.meta.env.VITE_APP_BUILD_MODE == "standalone") {
		iframeUrl = new URL("vendor_app/index.html", window.location.toString());
	}

	const iframeUrlSearchParams = iframeUrl.searchParams;

	for (const [key, value] of windowSearchParams) {
		iframeUrlSearchParams.set(key, value);
	}

	iframeUrlSearchParams.set("gameJwt", props.buildConfig.GameJwt);
	iframeUrlSearchParams.set(
		"fxIdAdapter",
		FxIdDomainStoreEnumsSupportedWebPublishingPlatform[window.FxIdSdk!.Adapter]
	);

	iframeUrl.hash = document.location.hash;

	log.info("Iframe searchParams: %o", iframeUrlSearchParams);

	useEffect(() => {
		if (contentRef != null && contentRef.contentWindow != null) {
			log.info("Registering iframe");
			window.FxIdSdk!.RegisterIframeWindow(contentRef.contentWindow);
		} else {
			log.info("IFrame still loading");
		}
	}, [contentRef]);
	// const mountNode = contentRef?.contentWindow?.document?.body;

	log.info("Loading game iframe at %s", iframeUrl.toString());

	return (
		<iframe
			src={iframeUrl.toString()}
			ref={(r) => setContentRef(r)}
			data-cmp-ab="1"
			allow={"autoplay"}
			style={{
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				width: "100%",
				height: "100%",
				border: "none",
				margin: 0,
				padding: 0,
				overflow: "hidden"
			}}
		/>
	);
};
